import { render, staticRenderFns } from "./AlacakTuruPicker.vue?vue&type=template&id=e95351a8&scoped=true"
import script from "./AlacakTuruPicker.vue?vue&type=script&lang=ts"
export * from "./AlacakTuruPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e95351a8",
  null
  
)

export default component.exports